import { useRecoilValue } from 'recoil';
import {
  actualityAggregatedScopedEvents,
  actualityAggregatedStatsSelectedSubGroup,
} from '../store/actuality.kpi.state';
import ActualityEventsList from './ActualityEventsList';

const ActualityAggregatedStatsEventsList = () => {
  const selectedSubGroup = useRecoilValue(
    actualityAggregatedStatsSelectedSubGroup,
  );
  const events = useRecoilValue(
    actualityAggregatedScopedEvents(selectedSubGroup),
  );

  return <ActualityEventsList events={events} />;
};

export default ActualityAggregatedStatsEventsList;
